:host {
  display: grid;
  block-size: 100%;
  overflow: auto;
  grid-template-rows: max-content 1fr max-content;
}

.section {
  display: contents;
}

.main {
  overflow: auto;
}

.tree-view {
  display: block;
  block-size: 100%;
  overflow: hidden;
}
